/*global window, document, jQuery, theme, Promise, confirm, localStorage, cartPopupDiscounts, fitCheck, InitProductPage, Pixlee*/
/*!
 * Theme custom scripts
 */
window.onload = function() {
  if($('.countdown-timer')) {
    
    var timer;
    showRemaining();
   timer = setInterval(showRemaining, 10000);
  }
}
function showRemaining() {
  var end = new Date($('.countdown-timer').first().attr('data-enddate'));
  
     var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
  
      var now = new Date();
      var distance = end - now;
      if (distance < 0) {
          clearInterval(timer);
          return;
      }
      var days = Math.floor(distance / _day);
      var hours = Math.floor((distance % _day) / _hour);
      var minutes = Math.floor((distance % _hour) / _minute);
      var seconds = Math.floor((distance % _minute) / _second);

      var tmr = days + ' DAY ' + hours + ' HRS ' + minutes + ' MINS ';
     $('.countdown-timer').text(tmr);
  }

function closeSubscribe() {
    $('.site-footer__newsletter').first().append($('#drip-ef-989729740').detach());
   $('#drip-ef-989729740 a.btn').remove();
    $('#fmc-modal-container').remove();
  }
function toTitleCase(str) {
    return str.replace(/(?:^|\s)\w/g, function(match) {
        return match.toUpperCase();
    });
}
// ================ OnLoad
jQuery(document).ready(function ($) {
  'use strict'; 

  if(window.location.href.indexOf('patent-library.com') > 0)
    window.location = 'http://www.yakima.com/pages/patents';
    // -|------------ Whitelabel Disable Cart Modifications
  if ($("body").hasClass("disablecart")) {
    $(".dealer-cart").hide();
    $(".add-to-cart").hide();
    $(".add-to-cart-force").hide();
  }
  var collectionName =  location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
  $('body').addClass(collectionName);
 
window.addEventListener('searchspring.afterSearch', function (event) {
  console.log('Searchspring scope: ', event);
  var gridItems = [];
  var cnt = 0;
        
 jQuery(event.target.meta.products).each(function() {
   if(jQuery(this)[0].vendor == 'yakimaproducts') {
      var variant = jQuery(this)[0].variants[0];
          var gridItem = {
              item_id: variant.sku,
              item_name: variant.name,
              affiliation: "Yakima Store",
              coupon: null,
              currency: "USD",
              discount: 0,
              index: cnt,
              item_brand: "Yakima",
              item_category: null,
              item_category2: null,
              item_category3: null,
              item_category4: null,
              item_category5: null,
              item_list_id: collectionName,
              item_list_name: toTitleCase(collectionName.split('-').join(' ')),
              item_variant: "Default",
              price: variant.price / 100,
              quantity: 1 
            };
     cnt++;
          gridItems.push(gridItem);
     
          console.log(gridItem);
   }
 });
  
    dataLayer.push({
      ecommerce: null
    }); // Clear the previous ecommerce object.

    dataLayer.push({
        event: "gtmEcommerceEvent",
        eventName: "view_item_list",
        eventCategory: "ecommerce",
        eventAction: "product impressions",
        eventLabel: null,
        nonInteractionHit: true,
        ecommerce: {
              items: gridItems 
        }
    });
  
}, false);
  function bindClicks() {
   jQuery('body.template-collection ul.grid li.grid__item').click(function() {
     
          var itemName = jQuery(this).find('.product-card__title').first().text();
          var itemSku = jQuery(this).find('.product-sku').first().text();
          var itemPrice = jQuery(this).find('.price__regular .price-item--regular>span.ng-binding').first().text().replace('$', '').replace(',', '');
          var collectionName =  $('.collection-hero__title').first().text().trim();
        dataLayer.push({
            ecommerce: null
        }); // Clear the previous ecommerce object.
        
   });
}
  setTimeout(function(){
  //  $('#drip-ef-997061356').attr('data-drip-embedded-form', '989729740').attr('action', 'https://www.getdrip.com/forms/989729740/submissions').attr('id', 'drip-ef-989729740');
  bindClicks();
  }, 2000);
  $('.product-tab .pager button').click(function () {
    var slider = $(this).parent().parent().find('.slider');
    var cnt = $(slider).find('.slide').length;
    var width = $(slider).width();
    //var height = $(slider).height();
    var pager = $(this).parent();
    var margin = $(slider).scrollLeft();
    var page =  parseInt(($(slider).scrollLeft() / (420)), 10) + 1;
    var isMobile = false;
    if ($(window).width() <= 700) {
      isMobile = true;
      margin = $(slider).scrollTop();
      page =  parseInt(($(slider).scrollTop() / 200), 10) + 1;
    }

    if ($(this).hasClass('icon-angle-right')) {
      if (page + 3 <= cnt) {
        if (isMobile) {
          $(slider).scrollTop(margin + 200);
        } else {
          $(slider).scrollLeft(margin + (420));
        }
        page += 1;
      }
    } else {
      if (page > 1) {
        page -= 1;

        if (isMobile) {
          if (margin >= (200)) {
            $(slider).scrollTop(margin - 200);
          } else {
            $(slider).scrollTop(0);
          }
        } else {
          if (margin >= (width / 3)) {
            $(slider).scrollLeft(margin - (420));
          } else {
            $(slider).scrollLeft(0);
          }
        }
      } else {
        $(slider).scrollLeft(0);
        $(slider).scrollTop(0);
      }
    }

    $(pager).find('.current').text(page + '-' + (page + 2));
  });

  if ($('#slick-block-activity-selector').length) {
    $('#slick-block-activity-selector').slick({
      infinite: false,
      slidesToShow: 3.5,
      speed: 500,
      dots: false,
      swipeToSlide: true,
      arrows: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if ($('#slick-block-landing-selector').length) {
    $('#slick-block-landing-selector').slick({
      infinite: false,
      slidesToShow: 3.5,
      speed: 500,
      dots: false,
      swipeToSlide: true,
      arrows: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

 //   if(localStorage.getItem('subscribe-seen') === null) { 
 //   window.setTimeout(function() {
//  		$('body').append('<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content"><p>Be a part of the road trip and never miss a turn. <br/>Subscribe to our mailing list.</p><span id="subscribe-container"></span></div></div>');
//   		$('#subscribe-container').append($('#drip-ef-989729740').detach());
 //     $('#subscribe-container .input-group').append('<a class="btn" style="margin-left: 10px;" onclick="closeSubscribe();">No Thanks</span>');
 // 		localStorage.setItem('subscribe-seen', '1');
  //  }, 5000);
 // }
  
  $('#fmc-banner-btn').click(function (e) {
    e.preventDefault();

    $('#get_started_button').trigger('click');
    // $(window).scrollTop(0);
    $("html, body").animate({ scrollTop: 0 }, 400);
  });

  /*==================
    Collapse module
  ====================*/
  var Collapse = {
    config: {
      toggle: '.js-collapse-toggle',
      container: '.js-collapse-container',
      dataAttribute: 'target'
    },

    init: function () {
      $('body').on('click', this.config.toggle, $.proxy(this.toggle, this));
    },

    toggle: function (e) {
      e.preventDefault();

      var $toggle = $(e.currentTarget);

      $toggle.toggleClass('collapsed');
      $('#' + $toggle.data(this.config.dataAttribute)).slideToggle();
    }
  };

  Collapse.init();

  /*==================
    Grid layout toggle
  ====================*/
  var CollectionGridLayoutSwitcher = {
    config: {
      button: '.js-grid-layout',
      container: '.js-grid--layout-container',
      dataAttribute: 'layout',
      list: {
        groupClass: 'grid-list-view'
      },
      grid: {
        groupClass: 'grid grid--uniform grid--view-items',
        itemClass: 'grid__item grid__item--collection-template'
      }
    },

    cache: {
      $container: null,
      gridItemClass: ''
    },

    init: function () {
      this.cache.$container = $(this.config.container);

      if (this.cache.$container.length) {
        $('body').on('click', this.config.button, $.proxy(this.changeLayout, this));

        this.cache.gridItemClass = this.cache.$container.children().first().attr('class').replace(this.config.grid.itemClass, '').trim();
      }
    },

    changeLayout: function (e) {
      e.preventDefault();

      var $button = $(e.currentTarget).prop('disabled', true);

      $button.siblings(this.config.button).prop('disabled', false);

      if ($button.data(this.config.dataAttribute) === 'list') {
        this.cache.$container
          .addClass(this.config.list.groupClass)
          .children()
            .removeClass(this.cache.gridItemClass);
      } else {
        this.cache.$container
          .removeClass(this.config.list.groupClass)
          .children()
            .addClass(this.cache.gridItemClass);
      }
    }
  };

  CollectionGridLayoutSwitcher.init();

  /*==================
    Filter Drawer
  ====================*/
  var FilterDrawer = {
    config: {
      open: '.js-filter-drawer-open',
      close: '.js-filter-drawer-close',
      toolbar: '.filters-toolbar-wrapper',
      openClass: 'open',
      drawerClass: 'js-drawer-open' // Locks body when filters are open
    },

    init: function () {
      $('body').on('click', this.config.open, $.proxy(this.open, this));
      $('body').on('click', this.config.close, $.proxy(this.close, this));
    },

    open: function (e) {
      e.preventDefault();

      $(this.config.toolbar).addClass(this.config.openClass);
      $('html, body').addClass(this.config.drawerClass);

      $(window).resize($.throttle(250, $.proxy(this.removeLock, this)));
    },

    close: function (e) {
      e.preventDefault();

      this.removeLock(e);
    },

    removeLock: function (e) {
      if (e.type !== 'resize' || window.innerWidth >= 750) {
        $(this.config.toolbar).removeClass(this.config.openClass);
        $('html, body').removeClass(this.config.drawerClass);

        $(window).unbind('resize', this.removeLock);
      }
    }
  };

  FilterDrawer.init();


  /*==================
    Product detail description
  ====================*/
  var ProductDetailDescription = {
    config: {
      button: '.product-single__read-more',
      container: '.product-single__description'
    },

    cache: {
      $container: null,
      $button: null
    },

    init: function () {
      this.cache.$container = $(this.config.container);

     /* if (this.cache.$container.length && this.cache.$container.height() > 120) {
        this.cache.$container
          .css('max-height', '100px')
          .after('<a class="product-single__read-more" href="#" title="Read more">...Read more</a>');

        this.cache.$button = this.cache.$container.next(this.config.button);
        this.cache.$button.click($.proxy(this.open, this));
      } */
    },

    open: function (e) {
      e.preventDefault();

      this.cache.$button.remove();
      this.cache.$container
        .css('max-height', '1000px');
        //.addClass('open');
    }
  };

  ProductDetailDescription.init();

  /*==================
    Product detail tabs
  ====================*/
  var ProductDetailTabs = {
    config: {
      tabButtons: '.product-single__tabs li',
      mobileTabButtons: '.product-single__tab-mobile',
      tabs: '.product-single__tab, .product-single__tab-mobile'
    },

    cache: {
      $tabButtons: null,
      $tabs: null
    },

    init: function () {
      this.cache.$tabButtons = $(this.config.tabButtons);

      if (this.cache.$tabButtons.length) {
        this.cache.$tabs = $(this.config.tabs);
        this.cache.$mobileTabButtons = $(this.config.mobileTabButtons);

        this.cache.$tabButtons.click($.proxy(this.switchTab, this));
        this.cache.$mobileTabButtons.click($.proxy(this.toggleTab, this));
      }
    },

    switchTab: function (e) {
      e.preventDefault();

      var $tabButton = $(e.currentTarget);

      if (!$tabButton.hasClass('active')) {
        var tabName = $tabButton.attr('class');

        this.cache.$tabButtons
          .filter('.active')
            .removeClass('active')
            .end()
          .filter('.' + tabName)
            .addClass('active');

        this.cache.$tabs
          .filter('.active')
            .removeClass('active')
            .end()
          .filter('.' + tabName)
            .addClass('active');
      }
    },

    toggleTab: function (e) {
      e.preventDefault();

      var $tabButton = $(e.currentTarget);

      if (!$tabButton.hasClass('active')) {
        var tabName = $tabButton.attr('class').replace('product-single__tab-mobile medium-up--hide ', '');

        this.cache.$tabButtons
          .filter('.active')
            .removeClass('active')
            .end()
          .filter('.' + tabName)
            .addClass('active');

        this.cache.$tabs
          .filter('.active')
            .removeClass('active')
            .end()
          .filter('.' + tabName)
            .addClass('active');
      } else {
        $tabButton.removeClass('active');

        this.cache.$tabs
          .filter('.active')
            .removeClass('active');
      }
    }
  };

  ProductDetailTabs.init();

  /*==================
    Product detail installation video
  ====================*/
  var ProductDetailVideo = {
    config: {
      button: '.js-drawer-open-video',
      drawerId: 'VideoPlayer',
      position: 'video',
      videoDataAttr: 'video-id'
    },

    cache: {
      $button: null,
      drawer: null
    },

    init: function () {
      this.cache.$button = $(this.config.button);

      if (this.cache.$button.length) {
        this.drawer = new theme.Drawers(this.config.drawerId, this.config.position, {
          onDrawerOpen: $.proxy(this.play, this),
          onDrawerClose: $.proxy(this.stop, this)
        });
      }
    },

    play: function () {
      var videoId = this.drawer.$activeSource.data(this.config.videoDataAttr);
      this.drawer.$drawer.find('iframe').attr('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&fs=0&modestbranding=1&rel=0');
   //   this.drawer.$drawer.find('iframe').attr('src', videoId);
    },

    stop: function () {
      this.drawer.$drawer.find('iframe').attr('src', '');
    }
  };

  ProductDetailVideo.init();

  /*==================
    Product detail spare parts
  ====================*/
  var ProductSparePartsAndAccessories = {
    config: {
      containerAccessories: '.product-single__tab.tab-accessories .grid',
      containerParts: '.product-single__tab.tab-spareparts .grid'
    },

    cache: {
      baseUrl: '/products/',
      $containerAccessories: null,
      $containerParts: null
    },

    init: function () {
      
      if (typeof window.YakimaProductAccessories !== 'undefined') {
        this.cache.$containerAccessories = $(this.config.containerAccessories);

        this.getProducts(window.YakimaProductAccessories, 'accessories');
      }

      if (typeof window.YakimaProductSpareParts !== 'undefined') {
        this.cache.$containerParts = $(this.config.containerParts);

        this.getProducts(window.YakimaProductSpareParts, 'parts');
      }
    },
    getProducts: function (products, type) {
      var i = 0;
      var productCalls = [];

      for (i = 0; i < products.length; i += 1) {
        var productCall = $.get(ProductSparePartsAndAccessories.cache.baseUrl + products[i] + '?view=card').then(function (response) {
          if (type === 'parts') {
            ProductSparePartsAndAccessories.renderCard(response, ProductSparePartsAndAccessories.cache.$containerParts);
          } else {
            ProductSparePartsAndAccessories.renderCard(response, ProductSparePartsAndAccessories.cache.$containerAccessories);
          }
        });

        productCalls.push(productCall);
      }

      //$.when.apply($, productCalls).then(function () {
      //  console.log('Products rendered');
      //});

      productCalls.reduce(function (promiseChain, currentFunction) {
        return promiseChain.then(currentFunction);
      }, Promise.resolve([]));
      //.then(function () {
      //  console.log('Products rendered');
      //});
    },

    renderCard: function (product, $container) {
      $container.append('<li class="grid__item small--one-half medium--one-third large--one-third widescreen--one-quarter">' + product + '</li>');
    }
  };

  ProductSparePartsAndAccessories.init();

  /*==================
    Product detail variation selection helper
  ====================*/
  var ProductVariationHelper = {
    config: {
      container: '[data-section-type="product"]',
      backInStockButton: '#BIS_trigger',
      //oosMessage: '.out-of-stock-message',
      outOfStockButton: '.btn--out-of-stock',
      variantDataContainer: '#VariantJson-product-template',
      productTabs: '.product-single__tab',
      productTabsNav: '.product-single__tabs li, .product-single__tab-mobile',
      productThumbs: '.product-single__thumbnails-product-template',
      pixleeContainer: '#pixlee_container'
    },

    cache: {
      $container: null,
      $backInStockButton: null,
      //$oosMessage: null,
      $outOfStockButton: null,
      variantData: null,
      $productTabs: null,
      $productTabsNav: null,
      $productThumbs: null,
      $pixleeContainer: null
    },

    init: function () {
      this.cache.$container = $(this.config.container);

      if (this.cache.$container.length && $(this.config.variantDataContainer).length) {
        this.cache.$backInStockButton = this.cache.$container.find(this.config.backInStockButton);
        //this.cache.$oosMessage = this.cache.$container.find(this.config.oosMessage);
        this.cache.$outOfStockButton = this.cache.$container.find(this.config.outOfStockButton);

        this.cache.$container.on('variantChange', $.proxy(this.variantChanged, this));
        this.cache.variantData = JSON.parse($(this.config.variantDataContainer).html());

        this.cache.$productTabs = this.cache.$container.find(this.config.productTabs);
        this.cache.$productTabsNav = this.cache.$container.find(this.config.productTabsNav);
        this.cache.$productThumbs = this.cache.$container.find(this.config.productThumbs);
        this.cache.$pixleeContainer = $(this.config.pixleeContainer);
      }
    },

    variantChanged: function (event) {
      var variant = event.variant;
      var variantMeta = this.cache.variantData[variant.id] || {};
      var $currentTab = null;
      var listContent = null;
      //
      // Switch Pixlee widget
      //
      // Pixlee is rendered on initial load in the product.liquid and product.product-system.liquid template files
      //
      if (this.cache.$pixleeContainer.length && typeof Pixlee !== undefined) {
        this.cache.$pixleeContainer.empty();
        Pixlee.addProductWidget({
          accountId:1016,
          widgetId:610039,
          skuId:variant.sku
        });
      }
      console.log('variant', variantMeta);

      // Only hide the button if user is not in Canada
      if (!$('body').hasClass('geo-ready ca')) {
        if (variant.available) {
          this.cache.$backInStockButton.hide();
          //this.cache.$oosMessage.hide();
          this.cache.$outOfStockButton.hide();
        } else {
          this.cache.$backInStockButton
            .attr('data-variant-id', variant.id)
            .show();
          //this.cache.$oosMessage.show();
          this.cache.$outOfStockButton.show();
        }
      }

      $('#product-price').text('$' + variant.price/100 + '.00');
      // Update product pricing (NZ)
      if (typeof variantMeta.nz_price !== 'undefined' && variantMeta.nz_price !== null) {
        var nz_price = parseFloat(variantMeta.nz_price);
        $('[data-regular-price-nz]', this.cache.$container).text(theme.Currency.formatMoney(nz_price * 100), theme.moneyFormat);
      }
 // Update product description
      if (typeof variantMeta.long_description !== 'undefined' && variantMeta.long_description !== null) {
       $('#product-description', this.cache.$container).html(variantMeta.long_description);
     }
      console.log('subhead', variantMeta.subhead);
      if (typeof variantMeta.subhead !== 'undefined' && variantMeta.subhead !== null) {
       $('.product-single__subtitle', this.cache.$container).html(variantMeta.subhead);
     }
      // Update product thumbnail slider
      
        this.cache.$productThumbs.slick('slickUnfilter').slick('slickFilter', '[data-variant-sku="' + variant.sku + '"]');      
      

      // Update product details data
      if (variantMeta.features !== null || variantMeta.weight !== null || variantMeta.dimensions !== null || variantMeta.warranty !== null) {
        $currentTab = this.cache.$productTabs.filter('.tab-details').removeClass('hide');

        this.cache.$productTabsNav.filter('.tab-details').removeClass('hide');

        $('.feature-headline').each(function() {
          $(this).text(variantMeta.title);
        });
            
           $('#product-features')
            .html(variantMeta.features);

        // Weight
        if (variantMeta.weight === null) {
          $currentTab.find('.technical-specs .weight').addClass('hide');
        } else {
          $('.technical-specs .weight').first()
            .text('Weight: ' + variantMeta.weight + ' kg.')
            .removeClass('hide');
        }

         // Crossbar Spread
        if (variantMeta.minimum_crossbar_spread != null) {
         
          $('.technical-specs .minCrossbarSpread').first()
            .text('Minimum Crossbar Spread: ' + parseInt(variantMeta.minimum_crossbar_spread) + 'cm');
             $('.technical-specs .maxCrossbarSpread').first()
            .text('Maximum Crossbar Spread: ' + parseInt(variantMeta.maximum_crossbar_spread) + 'cm');
        }

       $('#kit-instruction-link').attr('href', 'https://assets.yakima.com/product/instructions/' + variant.sku);

        // Dimensions
        if (variantMeta.dimensions.length === null && variantMeta.dimensions.width === null && variantMeta.dimensions.height === null) {
          $currentTab.find('.technical-specs .dimensions').addClass('hide');
        } else {
          var text = 'Dimensions:';

          if (variantMeta.dimensions.length !== null) {
            text = text + ' L ' + variantMeta.dimensions.length + ' cm';
          }

          if (variantMeta.dimensions.width !== null) {
            text = text + ' x W ' + variantMeta.dimensions.width + ' cm';
          }

          if (variantMeta.dimensions.height !== null) {
            text = text + ' x H ' + variantMeta.dimensions.height + ' cm';
          }

          $('.technical-specs .dimensions').first()
            .text(text)
            .removeClass('hide');
        }
        
          //  var priceText = $('.price-item--sale').first().text().trim();
          //  var price = parseFloat(priceText.replace('Starting at ', '').replace('$', '').replace(',', ''));
         //   priceText = $('.price-item--regular').first().text().trim();
         //   var fullPrice = parseFloat(priceText.replace('Starting at ', '').replace('$', '').replace(',', ''));
         //   var discountPrice = price * ((100) / 100);
         //   var percentOff = (1 - (discountPrice / fullPrice)) * 100;
        //    var newText = '$' + discountPrice.toFixed(2) + ' <span style="font-size: 0.7em;font-weight:300;">save ' + percentOff.toFixed(0) + '%</span>';
        //	$('.price-item--sale').first().html(newText);

      } else {
        // Hide tab
        this.cache.$productTabsNav.filter('.tab-details').addClass('hide');
      }

      // Update product details data
      if (variantMeta.installation_details !== null || variantMeta.installation_link !== null || variantMeta.additional_installation_link !== null || variantMeta.installation_video !== null) {
        $currentTab = this.cache.$productTabs.filter('.tab-installation').removeClass('hide');

        this.cache.$productTabsNav.filter('.tab-installation').removeClass('hide');

        
        $currentTab.find('.feature-headline')
            .text(variantMeta.title);

        // Installation details
        if (variantMeta.installation_details === null || variantMeta.installation_details.length === 0) {
          $currentTab.find('.installation-specs').addClass('hide');
        } else {
          listContent = '';
          var i = 0;

          for (i = 0; i < variantMeta.installation_details.length; i += 1) {
            listContent = listContent + '<li>' + variantMeta.installation_details[i] + '</li>';
          }

          $currentTab.find('.installation-specs')
              .find('ul')
                .html(listContent)
                .end()
              .removeClass('hide');
        }

        // Resources
        if (variantMeta.installation_link === null && variantMeta.additional_installation_link === null) {
          $currentTab.find('.resources').addClass('hide');
        } else {
          listContent = '';

          if (variantMeta.installation_link !== null) {
            listContent += '<li>' + variantMeta.installation_link + '</li>';
          }

          if (variantMeta.additional_installation_link !== null) {
            listContent += '<li>' + variantMeta.additional_installation_link + '</li>';
          }
          
           if (variantMeta.third_installation_link !== null) {
            listContent += '<li>' + variantMeta.third_installation_link + '</li>';
          }

           if (variantMeta.fourth_installation_link !== null) {
            listContent += '<li>' + variantMeta.fourth_installation_link + '</li>';
          }
          
           if (variantMeta.fifth_installation_link !== null) {
            listContent += '<li>' + variantMeta.fifth_installation_link + '</li>';
          }
          
           if (variantMeta.sixth_installation_link !== null) {
            listContent += '<li>' + variantMeta.sixth_installation_link + '</li>';
          }
          $('.tab-installation .resources')
              .find('ul')
                .html(listContent)
                .end()
              .removeClass('hide');
        }

        // Video
        if (variantMeta.installation_video === null) {
          $currentTab.find('#shopify-section-product-video').addClass('hide');
        } else {
          var source = $('#shopify-section-product-video .video-thumbnail img').data('src');

          source = source.replace('#vid', variantMeta.installation_video);

          $('#shopify-section-product-video')
            .find('.js-drawer-open-video')
              .attr('data-video-id', variantMeta.installation_video)
              .find('img')
                .attr('src', source)
                .end()
              .end()
            .removeClass('hide');
        }
      } else {
        // Hide tab
        this.cache.$productTabsNav.filter('.tab-installation').addClass('hide');
      }

  $('.product-single__tab.tab-accessories .grid').first().empty();
  $('.product-single__tab.tab-spareparts .grid').first().empty();
      
      // Accesories tab
      if (variantMeta.accessories !== null && variantMeta.accessories.length > 0) {
        $currentTab = this.cache.$productTabs.filter('.tab-accessories');

        this.cache.$productTabsNav.filter('.tab-accessories').removeClass('hide');

        $currentTab.find('.grid__item').remove();

        ProductSparePartsAndAccessories.getProducts(variantMeta.accessories, 'accessories');
      } else {
        // Hide tab
        this.cache.$productTabsNav.filter('.tab-accessories').addClass('hide');
      }

      // Spare parts tab
      if (variantMeta.spare_parts !== null && variantMeta.spare_parts.length > 0) {
        $currentTab = this.cache.$productTabs.filter('.tab-spareparts');

        this.cache.$productTabsNav.filter('.tab-spareparts').removeClass('hide');

        $currentTab.find('.grid__item').remove();

        ProductSparePartsAndAccessories.getProducts(variantMeta.spare_parts, 'parts');
      } else {
        // Hide tab
        this.cache.$productTabsNav.filter('.tab-spareparts').addClass('hide');
      }

      
      //Update Locally 
   //   this.cache.$productTabsNav.filter('#lcly-dealers-3').html('');
   //   var lcly_config_3 = {
    //                    id: '3',
    //                    company_name: 'Yakima',
    //                    button_text: 'See all local stores',
    //                    button_id: 'HTML',
   //                     company_id: '52',
    //                    show_dealers: '1',
    //                    css: '3',
    //                    upc: variant.barcode,
    //                    n_related_styles: '3',
    //                    lang: 'en-us',
    //                    currency: 'USD',
    //                    n_dealers: '5',
    //                    no_link: '1'
    //                  };
    //                  var lcly_query_3 = Object.keys(lcly_config_3).reduce(function(a,k){
    //                    a.push(encodeURIComponent(k) + '=' + encodeURIComponent(lcly_config_3[k]));return a
    //                  },[]).join('&');
    //                  var lcly_endpoint_3 = 'https://Yakima.locally.com/stores/map.js?' + lcly_query_3;
    //                  document.getElementById('lcly-script-3').src = lcly_endpoint_3;
    //  console.log('lclyconfig', document.getElementById('lcly-script-3').src);
        
      
      //Update Discounts

      dataLayer.push({
        ecommerce: null
    }); 
    
    dataLayer.push({
        event: "gtmEcommerceEvent",
        eventName: "view_item",
        eventCategory: "ecommerce",
        eventAction: "product detail view",
        eventLabel: variant.name,
        nonInteractionHit: true,
        ecommerce: {
            items: [{
              item_id: variant.sku,
              item_name: variant.name,
                affiliation: "Yakima Store",
                coupon: null, 
                currency: "USD",
                discount: 0,
                item_brand: "Yakima",
                item_category: null, 
                item_category2: null, 
                item_category3: null, 
                item_category4: null, 
                item_category5: null, 
                item_variant: variant.title, 
                price: variant.price/100,
                quantity: 1
            }]
        }
    });
      
      window.setTimeout(function () {
        fitCheck();
       // InitProductPage();
      console.log('set image');
      jQuery('.product-single__thumbnail').first().click();
      }, 100);
    }
  };

  ProductVariationHelper.init();

  /*==================
    Collection and Product breadcrumbs
  ====================*/
  var BreadcrumbsHelper = {
    config: {
      container: '.collection-breadcrumbs__list',
      collectionDataContainer: '#CollectionDataJson-breadcrumbs',
      storageItemKey: 'ykmBreadcrumbs'
    },

    cache: {
      $container: null,
      collectionData: null,
      currentCollection: null,

      // Collection data that doesn't exist in the Shopify admin
      collectionsTemp: {
        'roof-racks' : {
          title: 'Roof Racks',
          url: null
        },
        'truck-racks' : {
          title: 'Truck Racks',
          url: '/collections/truck-rack-systems'
        },
        'fish' : {
          title: 'Fish',
          url: null
        }
      },

      // Collection groups
      collectionGroups: {
        // Roof Racks
        "163799629872": "roof-racks",
        "163800416304": "roof-racks",
        "139411587120": "roof-racks",
        "163800186928": "roof-racks",
        "139411619888": "roof-racks",

        // Truck Racks
        "163843670064": "truck-racks",
        "163802906672": "truck-racks",
        "163803267120": "truck-racks",
        "139411652656": "truck-racks",

        // Bike
        "139409850416": "139409621040",
        "139409653808": "139409621040",
        "139409686576": "139409621040",
        "139409883184": "139409621040",
        "139409784880": "139409621040",
        "139409719344": "139409621040",

        // Cargo
        "139411259440": "139411062832",
        "139411226672": "139411062832",
        "139411161136": "139411062832",
        "139411193904": "139411062832",
        "139411095600": "139411062832",

        // Snow
        "139410440240": "139410309168",
        "139410341936": "139410309168",
        "139410473008": "139410309168",
        "139410407472": "139410309168",

        // Water
        "139410145328": "139409948720",
        "139409981488": "139409948720",
        "139410047024": "139409948720",
        "139410178096": "139409948720",
        "139410014256": "139409948720",

        // Basecamp
        "139411324976": "139411259440",
        "139411292208": "139411259440",
        "165723045936": "139411259440",
        "163820339248": "139411259440",

        // Fish
        "163843342384": "fish",

        // Trailer
        "139411423280": "139411357744"
      }
    },

    init: function () {
      this.cache.$container = $(this.config.container);

      if (this.cache.$container.length && (document.referrer.indexOf('collection') !== -1 || window.location.href.indexOf('collection') !== -1)) {
        this.cache.currentCollection = this.cache.$container.data('collection-id');
        this.cache.collectionData = JSON.parse($(this.config.collectionDataContainer).html());

        this.process();
        
        
        
      } else {
        // Clear saved bradcrumbs if not in a collection page or coming from a collection page
        this.clearBreadcrumbs();
      }
    },

    process: function () {
      var breadcrumbs = [];

      if (typeof this.cache.currentCollection !== 'undefined' && this.cache.currentCollection !== null) {
        // Render parent first
        if (typeof this.cache.collectionGroups[this.cache.currentCollection] !== 'undefined') {
          breadcrumbs.push(this.cache.collectionGroups[this.cache.currentCollection]);
        }

        breadcrumbs.push(this.cache.currentCollection);

        this.saveBreadcrumbs(breadcrumbs);
      } else {
        breadcrumbs = localStorage.getItem(this.config.storageItemKey);

        if (typeof breadcrumbs !== 'undefined' && breadcrumbs !== null) {
          breadcrumbs = breadcrumbs.split(',');
        }
      }

      if (Array.isArray(breadcrumbs) === true && breadcrumbs.length >= 1) {
        this.renderList(breadcrumbs);
        this.cache.$container.removeClass('hide');
      }
    },

    renderList: function (items) {
      var index;
      var collection = null;
      var collectionList = '';

      for (index = 0; index < items.length; index += 1) {
        collection = this.cache.collectionData[items[index]];

        // Check if collection data exists in the temporary data
        if (typeof collection === 'undefined' || collection === null) {
          collection = this.cache.collectionsTemp[items[index]];
        }

        collectionList += '<li class="collection-breadcrumbs__list--item">';

        if (typeof collection !== 'undefined' && collection !== null) {
          if (collection.url !== null) {
            collectionList += '<a href="' + collection.url + '">' + collection.title + '</a>';
          } else {
            collectionList += collection.title;
          }
        }

        collectionList += '</li>';
      }

      this.cache.$container.append(collectionList);
    },

    saveBreadcrumbs: function (breadcrumbs) {
      var storageValue = breadcrumbs.join(',');

      localStorage.setItem(this.config.storageItemKey, storageValue);
    },

    clearBreadcrumbs: function () {
      localStorage.removeItem(this.config.storageItemKey);
    }
  };

  BreadcrumbsHelper.init();

  /*==================
    Cart Drawer functionality
  ====================*/
  var CartDrawer = {
    config: {
      cartDrawer: '[data-cart-popup-wrapper]',
      cartIcon: '.site-header [data-cart-icon]',
      cartCount: '[data-cart-count]',
      cartClose: '[data-cart-popup-close]',
      cartErrorContainer: '.cart-popup__error',
      cartItems: '.cart-popup__items',
      cartNoItems: '.cart-popup__no-items',
      cartItem: '.cart-popup-item',
      checkoutItems: '.cart-popup__checkout-items',
      recommendedItem: '[data-cart-popup-recommended-product]',
      recommendedAddToCart: '[data-add-recommended-to-cart]',

      addToCart: '[data-add-to-cart]',
      quantityControls: '[data-cart-popup-wrapper] .cart-popup-item__quantity-field-controls .qty-control',
      quantityInput: '[data-quantity-input]',
      removeFromCart: '[data-cart-remove]',
      shippingRateLink: '[data-get-shipping-rate]',

      itemRegularPrice: '[data-cart-item-regular-price]',
      subTotal: '[data-cart-subtotal]',

      productSectionContainer: '#ProductSection-product-template',

      drawerClass: 'js-drawer-open',
      hiddenClass: 'cart-popup-wrapper--hidden',
      cartItemTemplateClass: 'cart-popup-item__template'
    },

    cache: {
      $htmlBody: null,
      $body: null,
      $drawer: null,
      $drawerOpenButton: null,
      $cartItemCount: null,
      $drawerCloseButton: null,
      $drawerErrorContainer: null,
      $drawerItems: null,
      $drawerNoItems: null,
      $checkoutItems: null,
      $recommendedItem: null,
      //$container: null,
      $subTotal: null,
      pendingRequest: false,
      themeProductInstance: null
    },

    // Initialize cart drawer
    init: function () {
      this.cache.$htmlBody = $('html, body');
      this.cache.$body = $('body');
      this.cache.$drawer = $(this.config.cartDrawer);
      this.cache.$drawerOpenButton = $(this.config.cartIcon);
      this.cache.$cartItemCount = $(this.config.cartCount, this.cache.$drawerOpenButton);
      this.cache.$drawerCloseButton = $(this.config.cartClose, this.cache.$drawer);
      this.cache.$drawerErrorContainer = $(this.config.cartErrorContainer, this.cache.$drawer);
      this.cache.$drawerItems = $(this.config.cartItems, this.cache.$drawer);
      this.cache.$drawerNoItems = $(this.config.cartNoItems, this.cache.$drawer);
      this.cache.$checkoutItems = $(this.config.checkoutItems, this.cache.$drawer);
      this.cache.$recommendedItem = $(this.config.recommendedItem, this.cache.$drawer);
      this.cache.$subTotal = $(this.config.subTotal, this.cache.$checkoutItems);
      this.cache.$shippingRateLink = $(this.config.shippingRateLink, this.cache.$checkoutItems);

      // Drawer open and close
      this.cache.$drawerOpenButton.click($.proxy(this.openDrawer, this));
      this.cache.$drawerCloseButton.click($.proxy(this.closeDrawer, this));

      // Cart functions
      //$(this.config.addToCart).click($.proxy(this.addToCart, this));
      this.cache.$body
        .on('click', this.config.quantityControls, $.proxy(this.updateQuantityField, this))
        .on('change', this.config.cartDrawer + ' ' + this.config.quantityInput, $.proxy(this.updateQuantity, this))
        .on('click', this.config.removeFromCart, $.proxy(this.removeFromCart, this))
        .on('click', this.config.recommendedAddToCart, $.proxy(this.addRecommendedProduct, this))
        .on('click', '.cart-popup-item__title a', function () {
          BreadcrumbsHelper.clearBreadcrumbs();
        });

      // Shipping rate
      this.cache.$shippingRateLink.click($.proxy(this.showShippingRateForm, this));

      // Update drawer when item has been added to cart (in theme.js)
      $(this.config.productSectionContainer).on('shopifyAddToCartSuccess', $.proxy(this.handleAddToCart, this));
    },

    openDrawer: function (e) {
      e.preventDefault();
      e.stopPropagation();
        var gridItems = [];
      var cnt = 1;

      this.cache.$drawer
        .prepareTransition()
        .removeClass(this.config.hiddenClass);

      this.cache.$htmlBody.addClass(this.config.drawerClass);

      
      // Add listener to body to close drawer on click
      $('#shopify-section-header, .page-container').one('click', $.proxy(this.closeDrawer, this));

      console.log('open drawer', $('.cart-popup__items'));
      var totalPrice = 0;
       $('.cart-popup__items .cart-popup-item').each(function() {
         
          var prodTitle = jQuery(this).find('.cart-popup-item__title a').first().text();
          var prodPrice = jQuery(this).find('.cart-item-regular-price').first().text().replace('$', '').replace(',', '');
          var prodQty = jQuery(this).find('.cart-popup-item__quantity-field-input').first().val();
         var prodSku = jQuery(this).find('.product-details__item').first().text().replace('SKU: #', '');
          var gridItem = {
                item_id: prodSku,
                item_name: prodTitle,
                affiliation: "Yakima Store",
                coupon: null, 
                currency: "USD",
                discount: 0,
                index: cnt, 
                item_brand: "Yakima",
                item_category: null, 
                item_category2: null, 
                item_category3: null, 
                item_category4: null, 
                item_category5: null, 
                item_variant: "Default", 
                price: parseFloat(prodPrice), 
                quantity: parseFloat(prodQty)
            };
         cnt++;
         totalPrice += parseInt(prodPrice);
            gridItems.push(gridItem);
       });
      dataLayer.push({
          ecommerce: null
      }); 
      dataLayer.push({
          event: "gtmEcommerceEvent",
          eventName: "view_cart",
          eventCategory: "ecommerce",
          eventAction: "view cart",
          eventLabel: null,
          nonInteractionHit: false,
          ecommerce: {
              items: gridItems
          }
      });
        localStorage.setItem('cart', JSON.stringify(gridItems));
      
    },

    closeDrawer: function (e) {
      e.preventDefault();

      if (e.currentTarget === this.cache.$drawerCloseButton[0]) {
        $('#shopify-section-header, .page-container').off('click', $.proxy(this.closeDrawer, this));
      }

      this.cache.$drawer
        .prepareTransition()
        .addClass(this.config.hiddenClass);

      this.cache.$htmlBody.removeClass(this.config.drawerClass);
    },

    handleAddToCart: function (e) {
      console.log('Event', e);

     
      // Use theme Product instance to use functions in theme.js
      if (this.cache.themeProductInstance === null) {
        this.cache.themeProductInstance = e.productInstance;
      }

      this.cache.themeProductInstance._handleButtonLoadingState(false);

      this.cache.$drawerItems.addClass('loading');

      $.getJSON('/cart.js')
        .done(function (cart) {
          this.cache.themeProductInstance._setCartQuantity(cart.item_count);
          this.cache.themeProductInstance._setCartCountBubble(cart.item_count);

          this.updateDrawer(cart);
          this.openDrawer(e);
        }.bind(this))
        .fail($.proxy(this.handleError, this));

        var sku = e.cartItem.sku;
        console.log('adding To Cart:', sku);
        console.log(e.productInstance.productSingleObject);

        if(e.productInstance.productSingleObject.tags.includes('Close Out') && sku != '8005045' && sku != '8005046' && sku != '8005047' && sku != '8005048' && sku != '8005063') {
          console.log('Adding Closeout item');
          var container = '<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content">';
          jQuery('body').first().append(container + '<h2>Important Notice: Final Sale Item</h2><p>You’ve added a Deep Discount item to your cart. Please note: Deep Discount items are final sale and cannot be returned.</p><div class="actions"><a onclick="closeFMCModal();" class="button reversed">Close</a><a class="button close outline" href="#" onclick="closeFMCModal()">I Agree</a></div></div></div>');
     
        }
      
     
        dataLayer.push({
            ecommerce: null
        }); 
        
        dataLayer.push({
            event: "gtmEcommerceEvent",
            eventName: "add_to_cart",
            eventCategory: "ecommerce",
            eventAction: "add to cart",
            eventLabel: e.productInstance.productSingleObject.title,
            nonInteractionHit: false,
            ecommerce: {
                items: [{
                    item_id: e.productInstance.productSingleObject.variants[0].sku,
                    item_name: e.productInstance.productSingleObject.title,
                    affiliation: "Yakima Store",
                    coupon: null, 
                    currency: "USD",
                    discount: 0,
                    item_brand: "Yakima",
                    item_category: null, 
                    item_category2: null, 
                    item_category3: null, 
                    item_category4: null, 
                    item_category5: null, 
                    item_variant: e.productInstance.productSingleObject.variants[0].public_title,
                    price: e.productInstance.productSingleObject.price/100,
                    quantity: 1
                }]
            }
        });
    },

    updateDrawer: function (cart) {
      console.log('Update drawer', cart);

      var template = $('.' + this.config.cartItemTemplateClass, this.cache.$drawer);
      var elements = {
        image: '[data-cart-popup-image]',
        title: '[data-cart-popup-title]',
        sku: '[data-cart-popup-item-sku]',
        qty: '[data-quantity-input]',
        originalPrice: '[data-cart-item-regular-price]',
        discount: '[data-cart-item-discounted-price-group]',
        finalPrice: '[data-cart-item-final-price]',
        remove: '[data-cart-remove]'
      };

      this.cache.$drawerItems.empty();

      $.each(cart.items, function (key, item) {
        var $itemTemplate = template.clone().removeClass(this.config.cartItemTemplateClass + ' hide');

        // Image
        if (item.featured_image !== null && item.featured_image.url !== null) {
          $itemTemplate
            .find(elements.image)
            .attr({
              alt: item.featured_image.alt,
              src: item.featured_image.url
            })
            .removeClass('hide');
        }

        // Product tags
        $.getJSON({
          url: '/products/' + item.handle + '.js'
        }).done(function (product) {
          $itemTemplate.find('[data-cart-popup-item-tags]').text(product.tags);
        });

        $itemTemplate
          .attr('data-cart-line', (key + 1))
          .find(elements.title)
            .text(item.title)
            .attr('href', item.url)
            .end()
          .find(elements.sku)
            .text('SKU: #' + item.sku)
            .end()
          .find(elements.qty)
            .val(item.quantity)
            .end()
          .find(elements.originalPrice)
            .text(theme.Currency.formatMoney(item.original_line_price))
            .end()
          .find(elements.remove)
            .attr({
            'aria-label': 'Remove ' + item.title,
            'href': '/cart/change?quantity=0&line=' + (key + 1)
          });

        // Append to cart items container
        this.cache.$drawerItems.append($itemTemplate);

        
      }.bind(this));

      if (cart.item_count > 0) {
        this.cache.$drawerItems.removeClass('hide');
        this.cache.$drawerNoItems.addClass('hide');
        this.cache.$checkoutItems.removeClass('hide');

        // Adjust subtotal
        this.cache.$subTotal.text(theme.Currency.formatMoney(cart.items_subtotal_price));

        this.getRecommendedProduct();
      } else {
        this.cache.$drawerItems.addClass('hide');
        this.cache.$drawerNoItems.removeClass('hide');
        this.cache.$checkoutItems.addClass('hide');
        this.cache.$recommendedItem.empty();
      }

      this.cache.$drawerItems.removeClass('loading');

      window.setTimeout(function() {
      if (typeof cartPopupDiscounts !== 'undefined') {
        console.log('recalculating discounts');
        cartPopupDiscounts();
      }
        }, 1000);
    },

    sendRequest: function (params) {
      if (this.cache.pendingRequest === false) {
        this.cache.pendingRequest = true;

        this.cache.$drawerErrorContainer.addClass('hide');
        this.cache.$drawerItems.addClass('loading');

        return $.post(params)
          .fail($.proxy(this.handleError, this))
          .always(function () {
            this.cache.$drawerItems.removeClass('loading');
            this.cache.pendingRequest = false;
          }.bind(this));
      }
    },

    handleError: function (error) {
      //console.log('Error', error);
      var errorMessage = 'Error, please try again';

      if (typeof error !== 'undefined' && error !== null && error.responseJSON !== null) {
        errorMessage = 'Error, ' + error.responseJSON.message;
      }

      this.cache.$drawerErrorContainer
        .text(errorMessage)
        .removeClass('hide');
    },

    updateQuantityField: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(e.currentTarget);
      var $input = $button.closest(this.config.cartItem).find(this.config.quantityInput);
      var quantity = parseInt($input.val(), 10);

      if ($button.data('control') === 'decrement') {
        quantity -= 1;
      } else {
        quantity += 1;
      }

      $input
        .val(quantity)
        .change();
    },

    updateQuantity: function (e) {
      var $lineItem = $(e.currentTarget).closest(this.config.cartItem);
      var $input = $lineItem.find(this.config.quantityInput);

      var line = $lineItem.data('cart-line');
      var quantity = parseInt($input.val(), 10);

      if (quantity < 1) {
        quantity = 1;
        $input.val(quantity);
      }

      var params = {
        url: '/cart/change.js',
        data: {
          'quantity': quantity,
          'line': line
        },
        dataType: 'json'
      };

      this.sendRequest(params)
        .done(function (cart) {
          //console.log('Success', cart);

          // Update our line item total
          $lineItem
            .find(this.config.itemRegularPrice)
            .html(theme.Currency.formatMoney((cart.items[line - 1].final_line_price)));

          // Update our cart total
          this.cache.$subTotal
            .text(theme.Currency.formatMoney(cart.items_subtotal_price));

          // Update Icon Count
          this.cache.$cartItemCount
            .text(cart.item_count);
          
          console.log('updating quantity:', quantity);
          console.log(cart.items[line - 1]);
  
          dataLayer.push({
              ecommerce: null
          }); 

          
          var cartItems = JSON.parse(localStorage.getItem('cart'));
          var qtyChange = 0;
          for(var i=0;i<cartItems.length;i++) {
            if(cartItems[i].item_id == cart.items[line - 1].sku) {
              qtyChange = quantity - cartItems[i].quantity;
              cartItems[i].quantity = quantity;
              console.log(cartItems[i].item_id, qtyChange);
            }
          }
          
        localStorage.setItem('cart', JSON.stringify(cartItems));
          
          dataLayer.push({
              event: "gtmEcommerceEvent",
              eventName: qtyChange > 0 ? "add_to_cart" : "remove_from_cart",
              eventCategory: "ecommerce",
              eventAction: qtyChange > 0 ? "add to cart" : "remove from cart",
              eventLabel: cart.items[line - 1].title,
              nonInteractionHit: false,
              ecommerce: {
                  items: [{
                      item_id: cart.items[line - 1].sku,
                      item_name: cart.items[line - 1].title,
                      affiliation: "Yakima Store",
                      coupon: null, 
                      currency: "USD",
                      discount: 0,
                      item_brand: "Yakima",
                      item_category: null, 
                      item_category2: null, 
                      item_category3: null, 
                      item_category4: null, 
                      item_category5: null, 
                      item_variant: cart.items[line - 1].variant_title,
                      price: cart.items[line - 1].price/100,
                        quantity:  qtyChange > 0 ? qtyChange : 0 - qtyChange
                  }]
              }
          });
          
        }.bind(this))
        .fail(function () {
          $input.val(quantity);
        });

     window.setTimeout(function() {
      if (typeof cartPopupDiscounts !== 'undefined') {
        console.log('recalculating discounts');
        cartPopupDiscounts();
      }
        }, 1000);
        
       
    },

    removeFromCart: function (e) {
      e.preventDefault();

      console.log('Delete item', e);

      if (confirm('Are you sure you want to remove this item?') === false) {
        return false;
      }

      var $lineItem = $(e.currentTarget).closest(this.config.cartItem);
      var line = $lineItem.data('cart-line');
      var params = {
        url: '/cart/change.js',
        data: {
          'quantity': 0,
          'line': line
        },
        dataType: 'json'
      };

      var prodTitle = jQuery($lineItem).find('.cart-popup-item__title a').first().text();
      var prodPrice = jQuery($lineItem).find('.cart-item-regular-price').first().text().replace('$', '').replace(',', '');
          var prodQty = jQuery($lineItem).find('.cart-popup-item__quantity-field-input').first().val();
         var prodSku = jQuery($lineItem).find('.product-details__item').first().text().replace('SKU: #', '');
      
      dataLayer.push({
          ecommerce: null
      }); 

      var cartItems = JSON.parse(localStorage.getItem('cart'));
      if(cartItems != null) {
          var idx = 0;
          for(var i=0;i<cartItems.length;i++) {
            if(cartItems[i].item_id == prodSku) {
              idx = i;
            }
          }
        console.log('removing item at position', idx);
        cartItems.splice(idx, 1);
        localStorage.setItem('cart', JSON.stringify(cartItems));
      }
          
      
      dataLayer.push({
          event: "gtmEcommerceEvent",
          eventName: "remove_from_cart",
          eventCategory: "ecommerce",
          eventAction: "remove from cart",
          eventLabel: prodTitle,
          nonInteractionHit: false,
          ecommerce: {
              items: [{
                      item_id: prodSku,
                      item_name: prodTitle,
                      affiliation: "Yakima Store",
                      coupon: null, 
                      currency: "USD",
                      discount: 0,
                      index: line, 
                      item_brand: "Yakima",
                      item_category: null, 
                      item_category2: null, 
                      item_category3: null, 
                      item_category4: null, 
                      item_category5: null, 
                      item_variant: "Default", 
                      price: parseFloat(prodPrice), 
                        quantity: parseFloat(prodQty)
                  }]
          }
      });
      
      this.sendRequest(params)
        .done(function (cart) {
          // Update cart counts
          if (this.cache.themeProductInstance !== null) {
            this.cache.themeProductInstance._setCartQuantity(cart.item_count);
            this.cache.themeProductInstance._setCartCountBubble(cart.item_count);
          } else {
            this.cache.$cartItemCount.text(cart.item_count);
          }

          $lineItem.fadeOut('250', function () {
            $lineItem.remove();

            if (cart.item_count > 0) {
              // Update our cart total
              this.cache.$subTotal.text(theme.Currency.formatMoney(cart.items_subtotal_price));

              // Re-index cart items
              $(this.config.cartItem, this.cache.$drawerItems).each(function (index, item) {
                $(item).attr('data-cart-line', index +  1);
              });

              this.getRecommendedProduct();
            } else {
              this.cache.$drawerItems.addClass('hide');
              this.cache.$drawerNoItems.removeClass('hide');
              this.cache.$checkoutItems.addClass('hide');
              this.cache.$recommendedItem.empty();
            }
          }.bind(this));
        }.bind(this));
    },

    getRecommendedProduct: function () {
      this.cache.$recommendedItem.slideUp('fast', function () {
        this.cache.$recommendedItem.empty();

        var params = {
          url: '/cart',
          data: {
            view: 'recommended'
          },
          dataType: 'html'
        };

        $.get(params)
          .done(function (response) {
            this.cache.$recommendedItem
              .html(response)
              .slideDown('fast');
          }.bind(this));
      }.bind(this));
    },

    addRecommendedProduct: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(e.currentTarget).attr('disabled', true);

      var params = {
        url: '/cart/add.js',
        data: {
          items: [
            {
              quantity: 1,
              id: $button.data('variant-id')
            }
          ]
        },
        dataType: 'json'
      };

      this.sendRequest(params)
        .done(function () {
          $.getJSON('/cart.js')
            .done(function (cart) {
              // Update cart counts
              if (this.cache.themeProductInstance !== null) {
                this.cache.themeProductInstance._setCartQuantity(cart.item_count);
                this.cache.themeProductInstance._setCartCountBubble(cart.item_count);
              } else {
                this.cache.$cartItemCount.text(cart.item_count);
              }

              this.updateDrawer(cart);
            }.bind(this))
            .fail($.proxy(this.handleError, this));
        }.bind(this));
    },

    showShippingRateForm: function (e) {
      e.preventDefault();

      var $shippingForm = $('.cart-popup__shipping-content', this.cache.$drawer);
      var $countries = $('.cart-popup__countries', $shippingForm);
      var $provinceField = $('.cart-popup__province', $shippingForm);
      var provinces = [];

      if ($countries.find('option').length === 1) {
        $countries.addClass('hide');
        provinces = $countries.find('option').first().data('provinces');
      }

      $.each(provinces, function (index, item) {
        $provinceField.append('<option value="' + item[0] + '">' + item[0] + '</option>');
      });

      $('.cart-popup__content', this.cache.$drawer).addClass('hide');

      $('.cart-popup__heading', this.cache.$drawer)
        .removeClass('hide')
        .first().addClass('hide');

      $shippingForm.removeClass('hide');

      $('[data-cart-popup-shipping-close]', this.cache.$drawer).one('click', $.proxy(this.closeShippingRateForm, this));
      $('.cart-popup__shipping-form', $shippingForm).submit($.proxy(this.getShippingRate, this));
    },

    closeShippingRateForm: function (e) {
      e.preventDefault();

      var $shippingForm = $('.cart-popup__shipping-content', this.cache.$drawer);

      $('[data-cart-popup-shipping-close]', this.cache.$drawer).off('click', $.proxy(this.closeShippingRateForm, this));
      $('.cart-popup__shipping-form', $shippingForm).off('submit', $.proxy(this.getShippingRate, this));
      $('[data-popup-cart-update-total]', $shippingForm).off('click', $.proxy(this.updateShippingText, this));

      $('.cart-popup__content', this.cache.$drawer).removeClass('hide');

      $('.cart-popup__heading', this.cache.$drawer)
        .addClass('hide')
        .first().removeClass('hide');

      $shippingForm.addClass('hide');
    },

    getShippingRate: function (e) {
      e.preventDefault();

      var $shippingForm = $('.cart-popup__shipping-content', this.cache.$drawer);
      var $provinceField = $('.cart-popup__province', $shippingForm);
      var $zipField = $('.cart-popup__zip', $shippingForm);
      var zip = $zipField.val();
      var $button = $(e.currentTarget).find('[type="submit"]');
      var buttonText = $button.text();
      var $shippingError = $('.cart-popup__error', $shippingForm);
      var $ratesTable = $('.cart-popup__shipping-quotes', $shippingForm).addClass('hide');

      if (zip.length === 0) {
        $zipField.addClass('input--error');

        return false;
      }

      var params = {
        url: '/cart/shipping_rates.json',
        data: {
          shipping_address: {
            zip: $zipField.val(),
            country: 'United States',
            province: $provinceField.val()
          }
        }
      };

      $shippingError.addClass('hide');
      $button
        .prop('disabled', true)
        .text('Processing...');

      $.getJSON(params)
        .done(function (response) {
          //console.log('Response:', response);
          var message = '<tr><td>Calculated at checkout</td></tr>';

          if (response.shipping_rates.length) {
            message = '';

            $.each(response.shipping_rates, function (key, item) {
              message += '<tr><td><div class="custom-control"><input type="radio" name="cart-popup-shipping-rate" id="cart-popup-shipping-rate-' + key + '" class="custom-control-input" value="' + item.name + ' $' + item.price + '" /><label class="custom-control-label" for="cart-popup-shipping-rate-' + key + '">' + item.name + '</label></td><td>$' + item.price + '</td></tr>';
            });
          }

          $('[data-popup-cart-update-total]', $shippingForm).one('click', $.proxy(this.updateShippingText, this));

          $ratesTable
            .find('[cart-popup-shipping-quotes]')
              .html(message)
              .end()
            .removeClass('hide');

          $button.prop('disabled', false).text(buttonText);
        }.bind(this))
        .fail(function (error) {
          var errorMessage = 'Error getting shipping rates, please try again.';

          if (typeof error !== 'undefined' && error !== null && typeof error.responseJSON !== 'undefined' && error.responseJSON !== null) {
            errorMessage = '';

            if (typeof error.responseJSON.zip !== 'undefined' && error.responseJSON.zip !== null) {
              errorMessage += 'Zip/Postal Code ' + error.responseJSON.zip[0];
            }

            if (typeof error.responseJSON.message !== 'undefined' && error.responseJSON.message !== null) {
              errorMessage += 'Error: ' + error.responseJSON.message;
            }
          }

          $shippingError
            .text(errorMessage)
            .removeClass('hide');

          $button.prop('disabled', false).text(buttonText);
        }.bind(this));
    },

    updateShippingText: function (e) {
      e.preventDefault();

      var $button = $(e.currentTarget);
      var $rate = $button.closest('.cart-popup__shipping-quotes').find('.cart-popup__shipping-quotes-table [name="cart-popup-shipping-rate"]:checked');
      var message = $rate.val();

      $('[data-get-shipping-rate]', this.cache.$drawer)
        .addClass('hide');

      $('[data-popup-cart-shipping]', this.cache.$drawer)
        .html(message)
        .removeClass('hide');

      this.closeShippingRateForm(e);
      $('.cart-popup__shipping-content .cart-popup__shipping-form', this.cache.$drawer)[0].reset();
    }
  };

  CartDrawer.init();

  /*==================
    Floating Modal functionality
  ====================*/
  var FloatingModal = {
    config: {
      openModalTrigger: '[data-toggle="modal"]',
      closeModalTrigger: '[data-dismiss="modal"]',

      activeModalClass: 'show'
    },

    cache: {
      //
    },

    init: function () {
      $('body').on('click', this.config.openModalTrigger, $.proxy(this.openModal, this));
    },

    openModal: function (e) {
      e.preventDefault();

      var $button = $(e.currentTarget);
      var $modal = $($button.data('target'));

      if ($modal.length) {
        var $backdrop = $('<div class="modal-backdrop"></div>');

        $backdrop
          .appendTo('body');

        $modal
          .show()
          .attr('aria-hidden', false);

        window.setTimeout(function () {
          $backdrop
            .addClass(this.config.activeModalClass);
        }.bind(this), 150);

        window.setTimeout(function () {
          $modal
            .addClass(this.config.activeModalClass);
        }.bind(this), 300);

        $(this.config.closeModalTrigger, $modal).one('click', $.proxy(this.closeModal, this));
      }
    },

    closeModal: function (e) {
      e.preventDefault();

      var $modal = $(e.currentTarget).closest('.modal');
      var $backdrop = $('.modal-backdrop');

      $modal.removeClass(this.config.activeModalClass);

      window.setTimeout(function () {
        $backdrop
          .removeClass(this.config.activeModalClass);
      }.bind(this), 300);

      window.setTimeout(function () {
        $modal
          .hide()
          .attr('aria-hidden', true);

        $backdrop.remove();
      }.bind(this), 450);
    }
  };

  FloatingModal.init();

  /*==================
    Carousel slider
  ====================*/
  var CarouselSlider = {
    config: {
      slider: '.carousel__slider-wrapper .carousel__slider',
      settings: {
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fas fa-chevron-right"></i></button>',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fas fa-chevron-left"></i></button>',
        infinite: false,
        slidesToShow: 3.5,
        slidesToScroll: 2,
        speed: 500,
        responsive: [
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 578,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    },

    cache: {
      $slider: null,
      slickSlider: null
    },

    init: function () {
      this.cache.$slider = $(this.config.slider);

      if (this.cache.$slider.length) {
        this.cache.$slider.each(function (index, element) {
          $(element)
            .slick(this.config.settings)
            .on('afterChange', this.updateCounter.bind(this));
            //.on('breakpoint', this.resetSlider.bind(this));
        }.bind(this));
      }

      $(document)
        .on('shopify:section:load', this.onSectionLoad.bind(this))
        .on('shopify:section:unload', this.onSectionUnload.bind(this));
    },

    onSectionLoad: function (evt) {
      $('[data-section-id]', evt.target)
        .find(this.config.slider)
        .slick(this.config.settings);
    },

    onSectionUnload: function (evt) {
      $('[data-section-id]', evt.target)
        .find(this.config.slider)
        .slick('unslick');
    },

    updateCounter: function (event, slick, currentSlide) {
      var $counter = slick.$slider.closest('.carousel__slider-wrapper').find('.carousel__slider-counter span');
      var startCount = currentSlide + 1;
      var endCount = startCount + slick.options.slidesToScroll;

      // Slider is at the end, check start and end count
      if (endCount > slick.slideCount) {
        endCount = slick.slideCount;
        startCount = endCount - slick.options.slidesToScroll;
      }

      $counter.text(startCount + ' - ' + endCount);
    },

    resetSlider: function (event, slick, breakpoint) {
      //console.log('Reset', slick, breakpoint);

      if (breakpoint === null) {
        slick.goTo(0, true);
      }
    }
  };

  CarouselSlider.init();

  window.setTimeout(function() {
    var dlrCnt = 0;
    var raCnt = 0;
    jQuery('.lcly-dealers-wrap-outer .lcly-dealer').each(function() {
      var dlr = jQuery(this).find('.lcly-dealer-name').first().text();
      if(dlr.indexOf('Rack Attack') >= 0) {
        raCnt++;
        if(raCnt > 2)
          jQuery(this).hide();
        else
          dlrCnt++;
      }
      else
        dlrCnt++;
      
      if(dlrCnt > 3)
        jQuery(this).hide();
      
    });
    jQuery('.lcly-dealers-wrap').first().css('height', '250px');
    
    jQuery('.shg-sld-right').mouseup(function(e) { 
      var slider = jQuery(this).closest('.shg-sld').find('.shg-sld-slides').first();
      
      slider.find('.shg-sibling').removeClass('shg-sibling');
      var activeIdx = 1;
      var cnt = 1;
      slider.find('.shg-sld-item').each(function() {
        cnt++;
        if(jQuery(this).hasClass('shg-sld-active')) 
          activeIdx = cnt;
      });
      var cnt = 1;
      slider.find('.shg-sld-item').each(function() {
        if(cnt == activeIdx - 1 || cnt == activeIdx + 1)
          jQuery(this).addClass('shg-sibling');
        cnt++;
      });
 
      
    });
  }, 600);
});
function SwapVideo() {
 jQuery('#tickettoride-video').html('<video playsinline autoplay loop controls id="bgvid" style="width: 100%"><source src="https://yakimaassets.s3.us-west-2.amazonaws.com/YakimaTicketToRide.mp4" type="video/mp4"></video>');
}
jQuery('a.chatLink').click(function() {  $zopim.livechat.window.show();});

/* === 2023 Redesign Scripts == */
(function ($) {
console.log('init popup');
  
    $.fn.VideoPopUp = function (options) {
        
        var defaults = {
            backgroundColor: "#000000",
            opener: "video",
            maxweight: "640",
            pausevideo: false,
            idvideo: ""
        };
        
        var patter = this.attr('id');

        var settings = $.extend({}, defaults, options);

        var video = document.getElementById(settings.idvideo);
        function stopVideo() {
            video.pause();
            video.currentTime = 0;
        }
        
        $('#' + patter + '').css("display", "none");
        $('#' + patter + '').append('<div id="opct"></div>');
        $('#opct').css("background", settings.backgroundColor);
        $('#' + patter + '').css("z-index", "100001");
        $('#' + patter + '').css("position", "fixed")
        $('#' + patter + '').css("top", "0");
        $('#' + patter + '').css("bottom", "0");
        $('#' + patter + '').css("right", "0");
        $('#' + patter + '').css("left", "0");
        $('#' + patter + '').css("padding", "auto");
        $('#' + patter + '').css("text-align", "center");
        $('#' + patter + '').css("background", "none");
        $('#' + patter + '').css("vertical-align", "vertical-align");
        $("#videCont").css("z-index", "100002");
        $('#videCont').append('<div id="closer_videopopup">&otimes;</div>');
        $("#" + settings.opener + "").on('click', function () {
            $('#' + patter + "").show();
            $('#'+settings.idvideo+'').trigger('play');

        });
        $("#closer_videopopup").on('click', function () {
            if(settings.pausevideo==true){
                    $('#'+settings.idvideo+'').trigger('pause');
                }else{
                    stopVideo();
                }
            $('#' + patter + "").hide();
        });
        return this.css({

        });
    };

 
  window.setTimeout(function() {  
    $('#AccessibleNav #mega-products').slick({  dots: true, infinite: true, speed: 500, fade: true, cssEase: 'linear', autoplay: true, autoplaySpeed: 4000 }); 
    $('.mobile-nav-wrapper #mega-products').first().slick({  dots: true, infinite: true, speed: 500, fade: true, cssEase: 'linear', autoplay: true, autoplaySpeed: 4000 }); 
    
  }, 1400);
  window.setTimeout(function() {  
    
    if ($(window).width() < 776) {
   //   $('#PageContainer .slick-slider').slick('unslick');
    //  $('.product-single__photos-container').first().slick();
    }
     $(window).on('resize', function(){
    if ($(window).width() < 768) {
      console.log('resize event');
   //   $('#PageContainer .slick-slider').slick('unslick');
    }
  });
    $('.gm-menu-mobile>li>a.gm-target').click(function() { 
      if($(this).parent().hasClass('gm-active')) {
        $('.gm-menu-mobile>li.gm-hidden').removeClass('gm-hidden');
        $('.gm-menu-mobile>li.gm-open').removeClass('gm-open');
        $(this).parent().parent().css('margin-left', '100%' ).animate({'margin-left': '0%'}, 200);
       
      }
      else {
        $('.gm-menu-mobile>li').addClass('gm-hidden');
        $(this).parent().removeClass('gm-hidden').addClass('gm-open').find('li.gm-hidden').removeClass('gm-hidden');
        console.log('set left', $('ul.gm-menu').first());
        
        $(this).parent().parent().css('margin-left', '100%' ).animate({'margin-left': '0%'}, 200);
            $('.mobile-nav-wrapper #mega-products').first().slick('unslick').slick({  dots: true, infinite: true, speed: 500, fade: true, cssEase: 'linear', autoplay: true, autoplaySpeed: 4000 }); 

         //  $('#AccessibleNav #mega-products').slick({  dots: true, infinite: true, speed: 500, fade: true, cssEase: 'linear' }); 
   //$('.mobile-nav-wrapper #mega-products').first().slick({  dots: true, infinite: true, speed: 500, fade: true, cssEase: 'linear' }); 
    
      }
    });
    $('.mobile-nav-wrapper ul.gm-links>li.gm-heading>.gm-target').click(function() { 
      
      if($(this).parent().hasClass('gm-active')) {
        $('ul.gm-group>li').removeClass('gm-hidden').removeClass('gm-open');
        $('ul.gm-links>li').addClass('gm-hidden');
        $('ul.gm-links>li').removeClass('gm-active');
        $('ul.gm-links>li.gm-heading').removeClass('gm-hidden');
        $('ul.gm-menu>li.gm-item>a').removeClass('gm-hidden');
        $(this).parent().parent().css('margin-left', '100%' ).animate({'margin-left': '0%'}, 200);
      }     
      else {
        $('ul.gm-grid>li').addClass('gm-hidden');
        $('ul.gm-group>li').addClass('gm-hidden');
        $(this).closest('ul.gm-grid>li.gm-item').removeClass('gm-hidden').addClass('gm-open');
        $(this).closest('.gm-has-submenu').removeClass('gm-hidden').addClass('gm-open');
        $(this).closest('.gm-has-submenu').find('.gm-item.gm-hidden').removeClass('gm-hidden');
        $('ul.gm-menu>li.gm-item>a').addClass('gm-hidden');
        
        $(this).parent().parent().css('margin-left', '100%' ).animate({'margin-left': '0%'}, 200);
      }
    });
    
  }, 400);
}(jQuery));
 function HideMenu() {
   $('html').removeClass('js-nav-open');
    $('.mobile-nav-wrapper').first().hide();
  }
